import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-plan-card',
  templateUrl: './plan-card.component.html',
  styleUrls: ['./plan-card.component.scss']
})
export class PlanCardComponent implements OnInit {
  @Input() plan: string;
  @Input() value: string;
  @Input() expiration: Date;
  @Input() hasManageButton: boolean;

  constructor() { }

  ngOnInit() {
  }

  get expirationString() {
    if (!(this.expiration instanceof Date)) {
      return "NOT DATE";
    }
    if (isNaN(this.expiration.getTime())) {
      return "Invalid";
    }
    return this.expiration.toLocaleDateString();
  }

}
